// extracted by mini-css-extract-plugin
export default {"melodyVideo":"NI-z","isFullWidth":"OI-z","landingPageVideo":"PI-z","play":"QI-z","iframeVideo":"RI-z","playHidden":"SI-z","fullwidth":"TI-z"};